import {LegacyPhoneListAdaptor} from './legacyPhoneListAdaptor.js';

export var LegacyContactInfoAdaptor = function(personData) {
    var contactInfo = {};
    
    // Constructor
    if (personData) {
        contactInfo.email = personData.email;
        contactInfo.phoneList = LegacyPhoneListAdaptor(personData.phoneNumbers).phoneList;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    return contactInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/adaptors/legacyContactInfoAdaptor.js
// module id = 40
// module chunks = 0